import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';
import Header from '../Header';
import Footer from '../Footer';
import SocketContext from '../SocketContext';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <SocketContext.Consumer>
        {
          socket => (
            <div>
              <Header socket={socket} />
              {this.props.children}
              <Footer /> 
            </div>
          )
        }
      </SocketContext.Consumer>
    );
  }
}

export default withStyles(normalizeCss, s)(Layout);